import request from '@/utils/request'
import qs from 'qs'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data: qs.stringify({
      username: data.username,
      password: data.password
    }),
    baseURL: 'https://api.unidt.com/voiceprint'
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token },
    baseURL: 'https://api.unidt.com/voiceprint'
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
    baseURL: 'https://api.unidt.com/voiceprint'
  })
}
